import { render, staticRenderFns } from "./InfoDialogHeader.vue?vue&type=template&id=50f4c392&scoped=true"
import script from "./InfoDialogHeader.vue?vue&type=script&lang=js"
export * from "./InfoDialogHeader.vue?vue&type=script&lang=js"
import style0 from "./InfoDialogHeader.vue?vue&type=style&index=0&id=50f4c392&prod&scoped=true&lang=css"
import style1 from "./InfoDialogHeader.vue?vue&type=style&index=1&id=50f4c392&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f4c392",
  null
  
)

export default component.exports